import Button from "../../../../common/ui/Button";
import { useNavigate } from "react-router-dom";

import classes from "./IntroPage.module.css";
import React, { useEffect } from "react";
import useTheme from "../../../../common/hooks/useTheme";
import sideAuthImg from "../../../../common/images/backgroundImgMobile.png";
import { isMobile } from "react-device-detect";
import useScreenInfo from "../../../../providers/useScreenInfo";
import QuestionnaireScreenWrapperMobile from "./QuestionnaireScreenWrapperMobile";
import { useDispatch } from "react-redux";
import { answersActions } from "../../store/answers-slice";
import { useAuth } from "../../../../providers/AuthProvider";
import { getUserInfo } from "../../../../common/network/Api";

const IntroPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { orientation } = useScreenInfo();
  const dispatch = useDispatch();
  const { AuthUser } = useAuth();

  useEffect(() => {
    if (AuthUser.biometrics_questionnaire_completed) {
      navigate("/platform/dashboard");
    }
  }, []);

  const handleStart = async () => {
    dispatch(answersActions.clearState());
    if (AuthUser.isImport) {
      let getUserData = await getUserInfo();
      const prefilledAnswers = {
        birth_date: getUserData.birthDate,
        gender: getUserData.gender,
        length_measurement_unit: getUserData.heightType,
        height: getUserData.height,
        mass_measurement_unit: getUserData.weightType,
        current_weight: getUserData.weight,
        target_weight: getUserData.targetWeight,
        primary_fitness_goal: getUserData.exerciseGoal,
        secondary_fitness_goal: getUserData.secondaryExerciseGoal,
        fat_mass_target: getUserData.fatMassTarget,
        exercise_frequency: getUserData.exerciseFrequency,
        muscle_mass_target: getUserData.muscleMassTarget,
        fat_loss_intensity: getUserData.fatLossIntensity,
        physical_activity: getUserData.physicalActivityAtLeisure,
        occupation_type: getUserData.occupation,
        resistance_training_level: getUserData.resistance_training_level,
        cardio_training_level: getUserData.cardio_training_level,
        interval_training_level: getUserData.interval_training_level,
        resistance_hypertrophy_focus_area:
          getUserData.resistance_hypertrophy_focus_area,
        resistance_strength_focus_area:
          getUserData.resistance_strength_focus_area,
        resistance_equipment: getUserData.resistance_equipment,
      };

      // Convert 0 values to empty strings
      const processedAnswers = Object.fromEntries(
        Object.entries(prefilledAnswers).map(([key, value]) => [
          key,
          value === 0 ? "" : value,
        ])
      );

      dispatch(
        answersActions.updateBiometricAnswers({
          ...processedAnswers,
        })
      );
    }
    navigate("/biometric-questionnaire");
  };

  if (isMobile && orientation === "landscape") {
    return <QuestionnaireScreenWrapperMobile />;
  }

  return (
    <div
      className={classes.container}
      style={{ height: isMobile ? "90vh" : "100vh" }}
    >
      <div
        className={classes.side}
        style={{
          backgroundImage: `url('${sideAuthImg}')`,
          backgroundPosition: "top center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: "100vh",
        }}
      />
      <div
        className={classes.main}
        style={{
          color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
        }}
      >
        <div className={classes.inner}>
          <div
            className={classes.title}
            style={{ color: theme.colors_ds.NEUTRAL_TEXT_STRONG }}
          >
            Welcome to our biometric questionnaire!
          </div>
          <div className={classes.subTitle}>
            Our experts have put together a few questions to provide the optimal
            training and nutrition recommendations that work for your lifestyle.
          </div>
          <div className={classes.btn}>
            <Button text="Start" customWidth="150px" onClick={handleStart} />
            <div
              className={classes.subtitle2}
              style={{ color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT }}
            >
              Will only take 6 min
            </div>
          </div>
        </div>
        <div className={classes.btnMobile}>
          <Button text="Start" customWidth="100%" onClick={handleStart} />
          <div
            className={classes.subtitle2}
            style={{ color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT }}
          >
            Will only take 6 min
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroPage;
